import styled from 'styled-components';


export const ContentContainer = styled.div `
  width: min(480px, 100%);
  background: white;
  padding: 20px;
  border-radius: 6px;
`